export default "/assets/images/easy-replacement.9bba4d2fa8c6192a.webp";